export default "__VITE_ASSET__bk4cMc6k__"